export enum ProductCategoryId {
  /**  
   id1: productId,
   id2: productSizeId,
   id3: orderItemId,
   id4: orderId,
   id6: menuHeadingId ??
   id7: menuId ??,
   id8: foodPackageId ??,
   id9: beveragePackageId ??,
   id10: foodAndBeveragePackageId ??
   id11: beverageMenuPackageId ??
   */
  SaleProducts = 1,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId,
   * id4: orderItemId,
   * id5: orderId ??
   * */
  PrepaidMenus = 2,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId,
   * id4: orderItemId,
   * id5: orderId ??
   * */
  MarketingPromotional = 3,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId,
   * id4: orderItemId,
   * id5: orderId ??
   * */
  CustomerServiceExpense = 6,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId,
   * id4: orderItemId,
   * id5: orderId ??
   * */
  OperationalExpense = 7,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId,
   * id4: orderItemId,
   * id5: orderId ??
   * */
  PettyCashExpense = 8,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId,
   * id4: orderItemId,
   * id5: orderId ??
   * */
  ContingentLiability = 9,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId,
   * id4: productSizeId
   * id5: orderItemId,
   * id6: orderId ??
   * */
  OtherRevenue = 10,
  /**
   * id1: productId,
   * id2: menuProductId
   * id3: menuId,
   * */
  FeesAndCharges = 11,
  /**
   * id1: menuId,
   * id2: courseId,
   * id3: productId
   * */
  Deposits = 12,
  /**
   * id1: productId
   * id2: giftcertificateId (optional)
   */
  GiftCertificates = 13,
  Inventory = 14,
  CreditAccounts = 15,
  Cashout = 16,
  DepositMenus = 17,
}

export const productTreeCategoryList = {
  marketingPromotional: {
    name: "Marketing & Promotional",
    value: ProductCategoryId.MarketingPromotional,
  },
  customerServiceExpense: {
    name: "Customer Service Expense",
    value: ProductCategoryId.CustomerServiceExpense,
  },
  operationalExpense: {
    name: "Operational Expense",
    value: ProductCategoryId.OperationalExpense,
  },
};

export interface TreeData {
  id: string;
  name: string;
  parentId: string;
  isSpecial?: boolean;
  isGroup: boolean;
  sequence: number;
  children?: TreeData[];
  /** True when this group node sits alongside product nodes under the same parent (invalid structure). */
  hasProductSiblings?: boolean;
}

/**
 * WHY?
 * whole id1.. id(n) in LineItem is super confusing. 
 * Helper resolveProductCategoryInfo() resolves them into easier to read ProductCategoryInfo props
 */
export interface ProductCategoryInfo {
  beverageMenuPackageId?: string;
  beveragePackageId?: string;
  courseId?: string;
  foodAndBeveragePackageId?: string;
  foodPackageId?: string;
  giftcertificateId?: string;
  menuHeadingId?: string;
  menuId?: string;
  menuProductId?: string;
  orderId?: string;
  orderItemId?: string;
  productId?: string;
  productSizeId?: string;
}

// account (non-sale) categories — managed in WizButler Accounting, per-restaurant switch via `Product.enabledRestaurants`
export const ACCOUNT_PRODUCT_CATEGORY_IDS = [
  ProductCategoryId.MarketingPromotional,
  ProductCategoryId.CustomerServiceExpense,
  ProductCategoryId.OperationalExpense,
  ProductCategoryId.CreditAccounts,
  ProductCategoryId.Deposits,
  ProductCategoryId.Cashout,
  ProductCategoryId.GiftCertificates,
  ProductCategoryId.PettyCashExpense,
  ProductCategoryId.ContingentLiability,
] as const;

export type AccountProductCategoryId = (typeof ACCOUNT_PRODUCT_CATEGORY_IDS)[number];

export const isAccountProductCategoryId = (productCategoryId: ProductCategoryId): productCategoryId is AccountProductCategoryId => (ACCOUNT_PRODUCT_CATEGORY_IDS as readonly ProductCategoryId[]).includes(productCategoryId);
